export default function Approach() {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative px-6 md:px-12 py-20 md:py-28 border-b border-rule bg-paper"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-3">
            <div className="overline text-slate reveal">If this is you</div>
            <div className="mono text-xs text-slate mt-3 reveal">— 01</div>
          </div>

          <div className="col-span-12 md:col-span-8 lg:col-span-7">
            <p
              data-testid="approach-statement"
              className="serif text-3xl sm:text-4xl md:text-5xl leading-[1.1] font-light text-ink reveal"
            >
              Your operations work — but you can feel the seams. Quality is
              variable. Ramp times have not improved in years. Your operating
              model has not been redesigned around how the work has changed.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
